import BaseModel from '@core/model';

import EmailDispositionEnum from '@constants/enums/email/disposition';

import { extractTextFromHtml } from '@utils/string';

import clock from '@plugins/dayjs';

import { User } from '@/models';

export class Email extends BaseModel {
    static entity = 'email';
    static runSetup = true;

    async setupLogic() {
        this.summary = extractTextFromHtml(this.body);
    }

    static fields() {
        return {
            ...super.fields(),
            id: this.string(null).nullable(),
            body: this.string(null).nullable(),
            summary: this.string(null).nullable(),
            subject: this.string(null).nullable(),
            disposition: this.enum(EmailDispositionEnum).nullable(),
            disposition_metadata: this.attr(null).nullable(),
            external_message_id: this.string(null).nullable(),
            sent_at: this.string(null).nullable(),
            recipient_id: this.string(null).nullable(),
            recipient_email: this.string(null).nullable(),
            recipient: this.belongsTo(User, 'recipient_id')
        };
    }

    static mock() {
        return {
            id: faker => faker.string.uuid(),
            subject: faker => faker.lorem.sentence(),
            disposition: faker => faker.helpers.arrayElement(Object.values(EmailDispositionEnum)),
            sent_at: faker => faker.date.recent({ days: 90 }).toISOString(),
            recipient: User.Api,
            recipient_id: (faker, item) => item.recipient?.id || null,
            recipient_email: (faker, item) => item.recipient?.email || null,
            body: (faker, item) =>
                '<p class="hidden d-none">{{lorem.paragraph}}</p>' +
                `<p>Hi ${item.recipient.name},</p>` +
                '<p>{{lorem.paragraph}}</p>' +
                '<p>kind regards,<br>{{person.fullName}}</p>'
        };
    }

    get time_of_send() {
        if (!this.sent_at) {
            return null;
        }

        return clock(this.sent_at).fromNow();
    }

    get is_sent() {
        return this.disposition === EmailDispositionEnum.SENT;
    }
    get is_delivered() {
        return this.disposition === EmailDispositionEnum.DELIVERED;
    }
    get is_rejected() {
        return this.disposition === EmailDispositionEnum.REJECTED;
    }
    get is_bounced() {
        return this.disposition === EmailDispositionEnum.BOUNCED;
    }
    get is_complained() {
        return this.disposition === EmailDispositionEnum.COMPLAINED;
    }
    get is_opened() {
        return this.disposition === EmailDispositionEnum.OPENED;
    }
}

export default Email;
